import { Outlet } from 'react-router-dom';
import { Theme } from '@radix-ui/themes';
import Navigation from './Navigation';

function App() {
    return (
        <Theme appearance="dark" accentColor="gray" radius="none" hasBackground={false}>
            <Navigation />
            <main>
                <Outlet />
            </main>
            <footer></footer>
        </Theme>
    );
}

export default App;
